import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "goencho_bag";
import { api } from "@/lib/api";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch (e) {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    const sync = (e) => {
      if (e.key === KEY) setItems(load());
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  useEffect(() => {
    api.get("/products").then((r) => {
      const ids = new Set((Array.isArray(r.data) ? r.data : []).map((p) => p.product_id));
      setItems((prev) => {
        const next = prev.filter((x) => ids.has(x.product_id));
        return next.length === prev.length ? prev : next;
      });
    }).catch(() => {});
  }, []);

  const add = (product, size, quantity = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.product_id === product.product_id && x.size === size);
      if (i >= 0) return prev.map((x, j) => (j === i ? { ...x, quantity: x.quantity + quantity } : x));
      return [...prev, { product_id: product.product_id, name: product.name, price: product.price, image: product.images?.[0], size, quantity }];
    });
    setOpen(true);
  };
  const update = (product_id, size, quantity) =>
    setItems((prev) => prev.map((x) => (x.product_id === product_id && x.size === size ? { ...x, quantity } : x)).filter((x) => x.quantity > 0));
  const remove = (product_id, size) => setItems((prev) => prev.filter((x) => !(x.product_id === product_id && x.size === size)));
  const clear = () => setItems([]);

  const value = useMemo(() => {
    const count = items.reduce((s, x) => s + x.quantity, 0);
    const subtotal = items.reduce((s, x) => s + x.quantity * x.price, 0);
    return { items, count, subtotal, open, setOpen, add, update, remove, clear };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
